import React, {Fragment} from "react";
import {Col, Descriptions, Row} from "antd";
import moment from "moment";

export const CariRecordTab = ({subCompanyCaris}) => {
    return (
        <Fragment>
            <Row
                type="flex"
                justify="space-between"
                style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    marginTop: "30px",
                    marginBottom: "20px"
                }}
            >
                Cari Kayıtları
            </Row>
            {subCompanyCaris?.data?.rows?.length > 0
                ? subCompanyCaris?.data?.rows?.map(cariRow => (
                      <Row style={{marginBottom: "40px"}}>
                          <Col span={24}>
                              <Descriptions columns={1} bordered>
                                  <Descriptions.Item span={1} label={"Borç"}>
                                      {cariRow?.totalOut && !isNaN(parseFloat(cariRow.totalOut))
                                          ? `${parseFloat(cariRow.totalOut).toLocaleString(
                                                "tr-TR",
                                                {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }
                                            )} TL`
                                          : "-"}
                                  </Descriptions.Item>
                                  <Descriptions.Item span={1} label={"Alacak"}>
                                      {cariRow?.totalIn && !isNaN(parseFloat(cariRow.totalIn))
                                          ? `${parseFloat(cariRow.totalIn).toLocaleString("tr-TR", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })} TL`
                                          : "-"}
                                  </Descriptions.Item>
                                  <Descriptions.Item span={1} label={"Bakiye"}>
                                      {cariRow?.total && !isNaN(parseFloat(cariRow.total))
                                          ? `${parseFloat(cariRow.total).toLocaleString("tr-TR", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })} TL`
                                          : "-"}
                                  </Descriptions.Item>
                              </Descriptions>
                              <Descriptions columns={2} bordered>
                                  <Descriptions.Item span={2} label={"Cari Kodu"}>
                                      {cariRow?.cariCode ?? "-"}
                                  </Descriptions.Item>
                                  <Descriptions.Item span={2} label={"Son Güncelleme Tarihi"}>
                                      {moment(cariRow?.lastUpdateDate).format("DD/MM/YYYY") ?? "-"}
                                  </Descriptions.Item>
                                  <Descriptions.Item span={2} label={"Vergi Numarası"}>
                                      {cariRow?.taxNo ?? "-"}
                                  </Descriptions.Item>
                                  <Descriptions.Item span={2} label={"Vergi Dairesi"}>
                                      {cariRow?.taxOffice ?? "-"}
                                  </Descriptions.Item>
                                  <Descriptions.Item span={2} label={"Adres"}>
                                      {cariRow?.address ?? "-"}
                                  </Descriptions.Item>
                              </Descriptions>
                          </Col>
                      </Row>
                  ))
                : "Cari kaydı bulunamadı"}
        </Fragment>
    );
};
